import styled from "styled-components";

export const BlogListWrapper = styled("div")(() => ({
  backgroundColor: "#ffffff",
  borderRadius: 12,
  padding: 16,
  boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
}));
export const BlogTable = styled("table")(() => ({
  width: "100%",
  borderCollapse: "collapse",
}));

export const BlogTh = styled("th")(() => ({
  textAlign: "left",
  padding: "12px 8px",
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  borderBottom: "1px solid #e5e7eb",
}));

export const BlogTd = styled("td")(() => ({
  padding: "12px 8px",
  fontSize: 14,
  color: "#111827",
  borderBottom: "1px solid #f1f5f9",
}));

export const StatusBadge = styled("span")<{ status?: boolean }>(
  ({ status }) => ({
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: status === true ? "#dcfce7" : "#fee2e2",
    color: status === true ? "#166534" : "#991b1b",
  }),
);

export const ActionButton = styled("button")(() => ({
  padding: "6px 10px",
  fontSize: 13,
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  marginRight: 8,
  backgroundColor: "#2563eb",
  color: "#ffffff",
  "&.delete": {
    backgroundColor: "#dc2626",
  },
}));
